import sv from '@drawbotics/drylus-style-vars';
import {
  Flex,
  FlexAlign,
  FlexItem,
  Padding,
  Paragraph,
  Shade,
  Size,
  Text,
  Title,
} from '@drawbotics/react-drylus';
import { css } from 'emotion';
import React from 'react';

import { createTranslate } from '~/utils/translation';

import notifications from '../images/notifications.svg';

const tt = createTranslate('pods.dashboard.routes.notifications');

const styles = {
  banner: css`
    border-radius: ${sv.borderRadiusLarge};
    background: ${sv.neutralLight};

    img {
      margin-bottom: -5px;
    }
  `,
};

export const InfoBanner = () => {
  return (
    <div className={styles.banner}>
      <Flex align={FlexAlign.END}>
        <FlexItem flex>
          <Padding size={{ vertical: Size.EXTRA_SMALL, horizontal: Size.DEFAULT }}>
            <Title size={4}>{tt('who_receives_emails')}</Title>
            <Paragraph>
              <Text shade={Shade.LIGHT}>{tt('emails_explained')}</Text>
            </Paragraph>
          </Padding>
        </FlexItem>
        <FlexItem>
          <img src={notifications} />
        </FlexItem>
      </Flex>
    </div>
  );
};
